<form [formGroup]="form" (change)="onFormChange()">
  <fieldset>
    <span><legend i18n>Period:</legend></span>
    @for (range of ranges(); track range.value) {
      <div class="radio-field">
        <input
          type="radio"
          [id]="range.label"
          name="period"
          [formControlName]="'period'"
          [value]="range.value.toString()"
        />
        <label [for]="range.label">{{ range.label }}</label>
      </div>
    }
    @if (picker()) {
      <app-date-range [min]="min()" [max]="max()" (dateRangeChange)="onDateRangeChange($event)" (canceled)="onCancel()">
        <div class="radio-field">
          <input type="radio" id="picker" name="period" [formControlName]="'period'" value="picker" />
          <label i18n for="picker">Custom period</label>
        </div>
      </app-date-range>
    }
    @if (all()) {
      <div class="radio-field">
        <input type="radio" id="all" name="period" [formControlName]="'period'" value="0" />
        <label i18n for="all">Since launch</label>
      </div>
    }
  </fieldset>
</form>
